/** @file Where an edit lands: setup values, or keys of the playhead animation at the playhead frame. */
import type { Id } from '@pose2d/format/types';
import type { ToolContext } from '../../panels/viewport/viewportTypes';

/** `frame` is a whole frame (a press pauses playback first, CB-05 B16; rounded here as well). */
export interface EditTarget { mode: 'setup' | 'animate'; animation: Id | null; frame: number }

/** null (with notice viewport.noAnimation) in Animate mode without a playhead animation (R-E1-06). */
export function editTargetOf(ctx: Pick<ToolContext, 'tool' | 'playhead' | 'notify'>): EditTarget | null {
  if (ctx.tool.mode === 'setup') return { mode: 'setup', animation: null, frame: 0 };
  if (ctx.playhead.animation === null) {
    ctx.notify({ kind: 'info', key: 'viewport.noAnimation' });
    return null;
  }
  return { mode: 'animate', animation: ctx.playhead.animation, frame: Math.max(0, Math.round(ctx.playhead.frame)) };
}
